import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from '@/lib/auth';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { RequireAuth } from '@/components/RequireAuth';
import { RequireAdmin } from '@/components/RequireAdmin';
import { MatterProvider } from '@/contexts/MatterContext';
import { Design } from '@/pages/Design';
import { Hearing } from '@/pages/Hearing';
import { Login } from '@/pages/Login';
import { Activate } from '@/pages/Activate';
import { Settings } from '@/pages/Settings';
import { Admin } from '@/pages/Admin';
import { Prep } from '@/pages/Prep';
import { BattleMap } from '@/pages/BattleMap';
import { Witnesses } from '@/pages/Witnesses';
import { CrossExamPlanPage } from '@/pages/CrossExamPlanPage';
import { Deadlines } from '@/pages/Deadlines';
import { MatterEditor } from '@/pages/MatterEditor';
import { Matters } from '@/pages/Matters';
import { Sessions } from '@/pages/Sessions';
import { AdminImport } from '@/pages/AdminImport';
import { AdminLegalSkills } from '@/pages/AdminLegalSkills';
import { AdminAuthorities } from '@/pages/AdminAuthorities';
import { AdminLearning } from '@/pages/AdminLearning';
import { AdminMatterSkills } from '@/pages/AdminMatterSkills';
import { AdminMatterDocuments } from '@/pages/AdminMatterDocuments';

// /sessions browser is built in 5.5.
export function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/hearing" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/activate/:token" element={<Activate />} />
            <Route
              path="/settings"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <Settings />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <RequireAdmin>
                    <MatterProvider>
                      <Admin />
                    </MatterProvider>
                  </RequireAdmin>
                </RequireAuth>
              }
            />
            <Route
              path="/hearing"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <Hearing />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/matters"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <Matters />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/matters/new"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <MatterEditor />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/matters/:id"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <MatterEditor />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/matters/:id/prep"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <Prep />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/matters/:id/witnesses"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <Witnesses />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/plans/:planId"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <CrossExamPlanPage />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/matters/:id/battle-map"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <BattleMap />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/matters/:id/deadlines"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <Deadlines />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/sessions"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <Sessions />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/admin/import"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <AdminImport />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/admin/legal-skills"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <AdminLegalSkills />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/admin/authorities"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <AdminAuthorities />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/admin/learning"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <AdminLearning />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/admin/matters/:matterId/skills"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <AdminMatterSkills />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route
              path="/admin/matters/:matterId/documents"
              element={
                <RequireAuth>
                  <MatterProvider>
                    <AdminMatterDocuments />
                  </MatterProvider>
                </RequireAuth>
              }
            />
            <Route path="/design" element={<Design />} />
            <Route path="*" element={<Navigate to="/hearing" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}
